import BaseApiService from '../base/BaseApiService';
import type { NotificationHistoryFilters, NotificationHistoryResponse } from '@app-types';

/**
 * Read-only client for the admin Notification History tab (PR6).
 */
class NotificationHistoryService extends BaseApiService {
  /**
   * Fetch a filtered, paginated page of notification delivery history.
   * Empty/undefined filters are stripped by buildQueryParams.
   */
  async getHistory(
    filters: NotificationHistoryFilters = {},
    page = 1,
    pageSize = 25
  ): Promise<NotificationHistoryResponse> {
    const params = this.buildQueryParams({
      ...filters,
      page,
      page_size: pageSize
    });
    return this.get<NotificationHistoryResponse>(`/admin/notification-history?${params}`);
  }
}

export const notificationHistoryService = new NotificationHistoryService();
export default notificationHistoryService;
